import {useState} from "preact/compat";

export const useFifthStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate
    } = props;

    // State to store all form values
    const [formValues, setFormValues] = useState({
        fsRating: "",
        additionalComment: ""
    });

    // Procedure to handle the form submission
    const handleSubmit = (e) => {
        // Prevents page from reloading
        e.preventDefault();

        // Synchronizes the payload state with the current step's form values
        handlePayloadUpdate({
            data: {
                question_type: "nps",
                rating: parseInt(formValues.fsRating, 10),
                input: formValues.additionalComment
            }
        });

        // Proceeds to the next step
        handleStepChange({
            action: "NEXT"
        });
    }

    // Procedure to handle all input value changes
    const handleChange = (e) => {
        // Destructured event props
        const {
            name,
            value
        } = e.target;

        // Assigns the new values to the formState data object
        setFormValues(prevState => {
            return {
                ...prevState,
                [name]: name === "fsRating" ? parseInt(value, 10) : value
            }
        })
    }

    return {
        formValues,
        handleChange,
        handleSubmit
    }
}